import React, { useState, useEffect } from 'react'
import Sidebar from '../mini-comp/Sidebar'
import Topbar from '../mini-comp/Topbar'
import {RiBuildingLine, RiPagesLine, RiCalendarLine, RiLeafLine, RiEyeLine} from 'react-icons/ri'
import axios from 'axios';
import Cookies from 'js-cookie';
import { Link, useNavigate } from 'react-router-dom';
import API_BASE_URL from '../../../config/api';

const AdminDashboard = () => {
  const navigate = useNavigate();
  const [totalCompanies, setTotalCompanies] = useState(0);
  const [totalCompaniesActive, setTotalCompaniesActive] = useState(0);
  const [totalCompaniesInactive, setTotalCompaniesInactive] = useState(0);
  const [totalModules, setTotalModules] = useState(0);
  const [totalPackages, setTotalPackages] = useState(0);
  const [totalHolidays, setTotalHolidays] = useState(0);
  const [hrManagers, setHrManagers] = useState([]);
  const [recentlyAddedCompanies, setRecentlyAddedCompanies] = useState([]);

  useEffect(() => {
    const token = Cookies.get('token');
    
    if (!token) {
      console.error('No token found in cookies');
      return;
    }

    axios.get(`${API_BASE_URL}/api/v1/billing/dashboard/`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    })
      .then(response => {
        console.log(response.data);
        setTotalCompanies(response.data.companies || 0);
        setTotalCompaniesActive(response.data.active_companies || response.data.activeCompanies || 0);
        setTotalCompaniesInactive(response.data.in_active_companies || response.data.inactiveCompanies || 0);
        setTotalModules(response.data.modules || 0);
        setTotalPackages(response.data.packages || 0);
        setTotalHolidays(response.data.holidays || 0);
        setHrManagers(response.data.hr_managers || []);
        setRecentlyAddedCompanies(response.data.last_4_companies || []);
      })
      .catch(error => {
        console.error('Error fetching admin dashboard data:', error);
      });
  }, []);

  const handleViewAllHrManagers = () => {
    navigate('/admin/hr-managers');
  };

  const handleViewAllRecentlyAddedCompanies = () => {
    navigate('/admin/all-companies');
  };

  const handleViewHrManagerDetails = (hrManagerId) => {
    navigate(`/admin/hr-manager/${hrManagerId}`);
  };

  const handleViewCompanyDetails = (companyId) => {
    navigate(`/admin/company-details/${companyId}`);
  };

  const handleAddHrManager = () => {
    navigate('/admin/add-hr-manager');
  };

  // Helper function to format date as "time ago"
  const getTimeAgo = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    const now = new Date();
    const seconds = Math.floor((now - date) / 1000);
    
    if (seconds < 60) return `${seconds} seconds ago`;
    const minutes = Math.floor(seconds / 60);
    if (minutes < 60) return `${minutes} minute${minutes > 1 ? 's' : ''} ago`;
    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `${hours} hour${hours > 1 ? 's' : ''} ago`;
    const days = Math.floor(hours / 24);
    if (days < 7) return `${days} day${days > 1 ? 's' : ''} ago`;
    const weeks = Math.floor(days / 7);
    if (weeks < 4) return `${weeks} week${weeks > 1 ? 's' : ''} ago`;
    const months = Math.floor(days / 30);
    if (months < 12) return `${months} month${months > 1 ? 's' : ''} ago`;
    const years = Math.floor(days / 365);
    return `${years} year${years > 1 ? 's' : ''} ago`;
  };

  const handleAddCompany = () => {
    navigate('/admin/add-company');
  };

  return (
    <div>
        <Topbar />
        <Sidebar />

        <>{ /* app-content-area-start */ }
        <div className="app-content-area">
            <div className="app-content-wrap">
                <div className="container-fluid">
                    <div className="row fix">
                        <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-6">
                            <div className="card">
                                <div className="card-body mini-card-body d-flex align-center gap-16">
                                    <div className="avatar avatar-xl bg-primary-transparent text-primary">
                                        <RiBuildingLine />
                                    </div>
                                    <div className="card-content">
                                        <span className="d-block fs-16 mb-5">Total Companies</span>
                                        <h2 className="mb-5">{totalCompanies}</h2>
                                        <span className="text-success">{totalCompaniesActive} Active</span>
                                        <span className="text-danger"> &nbsp; &nbsp;&nbsp;&nbsp;{totalCompaniesInactive} In-active</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-6">
                            <div className="card">
                                <div className="card-body mini-card-body d-flex align-center gap-16">
                                    <div className="avatar avatar-xl bg-warning-transparent text-warning">
                                        <RiPagesLine />
                                    </div>
                                    <div className="card-content">
                                        <span className="d-block fs-16 mb-5">Total Modules</span>
                                        <h2 className="mb-5">{totalModules}</h2>
                                        <span className="fs-9 text-muted">Leave, Payroll, Employee Management</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-6">
                            <div className="card">
                                <div className="card-body mini-card-body d-flex align-center gap-16">
                                    <div className="avatar avatar-xl bg-info-transparent text-info">
                                        <RiCalendarLine />
                                    </div>
                                    <div className="card-content">
                                        <span className="d-block fs-16 mb-5">Total Packages</span>
                                        <h2 className="mb-5">{totalPackages}</h2>
                                        <span className="fs-9 text-muted ml-5">Essential, Professional, Enterprise</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-6">
                            <div className="card">
                                <div className="card-body mini-card-body d-flex align-center gap-16">
                                    <div className="avatar avatar-xl bg-purple-transparent text-purple">
                                        <RiLeafLine />
                                    </div>
                                    <div className="card-content">
                                        <span className="d-block fs-16 mb-5">Total Holidays</span>
                                        <h2 className="mb-5">{totalHolidays}</h2>
                                        <span className="fs-12 text-muted">public holidays</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-xxl-6 col-xl-12">
                            <div className="card">
                                <div className="card-header justify-between">
                                    <h4 className="">HR Managers</h4>
                                    <Link className="btn btn-primary-light btn-sm text-primary" to="/admin/hr-managers">View All</Link>
                                </div>
                                <div className="card-body pt-15">
                                    <div className="table-responsive">
                                        <table className="table tbody-b-none text-nowrap">
                                            <thead>
                                                <tr>
                                                    <th>Full Name</th>
                                                    <th>Company</th>
                                                    <th>Email</th>
                                                    <th>Phone</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {hrManagers && hrManagers.length > 0 ? (
                                                    hrManagers.map((hrManager) => (
                                                        <tr key={hrManager.id || hrManager.user_id}>
                                                            <td>
                                                                <div className="d-flex-items gap-10">
                                                                    <div className="avatar avatar-xs radius-100">
                                                                        <img 
                                                                            className="radius-100" 
                                                                            src={hrManager.profile_picture || "assets/images/avatar/avatar-thumb-001.webp"} 
                                                                            alt={hrManager.full_name || hrManager.name || 'HR Manager'} 
                                                                        />
                                                                    </div>
                                                                    <h6>{hrManager.full_name || hrManager.name || `${hrManager.first_name || ''} ${hrManager.last_name || ''}`.trim() || 'N/A'}</h6>
                                                                </div>
                                                            </td>
                                                            <td>{hrManager.company_name || hrManager.company?.name || hrManager.company || 'N/A'}</td>
                                                            <td>{hrManager.email || 'N/A'}</td>
                                                            <td>{hrManager.phone || hrManager.phone_number || 'N/A'}</td>
                                                            <td>
                                                                <div className="d-flex-items gap-10">
                                                                    <button 
                                                                        className="btn-icon btn-success-light" 
                                                                        onClick={() => handleViewHrManagerDetails(hrManager.id || hrManager.user_id)}
                                                                        data-bs-toggle="tooltip" 
                                                                        data-bs-placement="top" 
                                                                        data-bs-title="View"
                                                                    >
                                                                        <RiEyeLine />
                                                                    </button>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="5" className="text-center py-4">
                                                            <span className="text-muted">No HR Managers found</span>
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-xxl-4 col-xl-12">
                            <div className="card">
                                <div className="card-header justify-between">
                                    <h4 className="">Recently Added Companies</h4>
                                </div>
                                <div className="card-body pt-15">
                                    <div className="announcement-list card-scrollbar">
                                        {recentlyAddedCompanies && recentlyAddedCompanies.length > 0 ? (
                                            recentlyAddedCompanies.map((company, index) => {
                                                const colors = ['bg-primary', 'bg-success', 'bg-info', 'bg-warning'];
                                                const color = colors[index % colors.length];
                                                return (
                                                    <div 
                                                        key={company.id || company.company_id || index} 
                                                        className="announcement-item"
                                                        style={{ cursor: 'pointer' }}
                                                        onClick={() => handleViewCompanyDetails(company.id || company.company_id)}
                                                    >
                                                        <div className={`bullet ${color} mt-5`} />
                                                        <div className="announcement-content">
                                                            <div className="announcement-header d-flex-between mb-10">
                                                                <h5>{company.trade_name || company.company_name || 'Unnamed Company'}</h5>
                                                                <span className="fs-12 text-muted">
                                                                    {company.registration_number}
                                                                </span>
                                                            </div>
                                                            <p className="mb-15">
                                                                {company.description || company.address || company.location || 'No description available'}
                                                            </p>
                                                            <div className="announcement-footer d-flex-between">
                                                                <span className="fs-12 text-body-secondary">
                                                                    {company.email || company.contact_email || 'No email'}
                                                                </span>
                                                                <div className="announcement-tags d-flex gap-10">
                                                                    <span className={`badge ${company.status === 'active' || company.has_subscription ? 'bg-label-success' : 'bg-label-danger'}`}>
                                                                        {company.has_subscription === 'active' || company.has_subscription ? 'Active' : 'Inactive'}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                );
                                            })
                                        ) : (
                                            <div className="text-center py-4">
                                                <span className="text-muted">No recently added companies</span>
                                            </div>
                                        )}
                                    </div>

                                    <div className="announcement-view-btn">
                                        <Link 
                                            to="/admin/all-companies"
                                            className="btn btn-primary w-100"
                                        >
                                            View All
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>
        { /* app-content-area-end */ }</>
    </div>
  )
}

export default AdminDashboard